export const addOrUpdateUrlParam = (name, value) => {
  let href = window.location.href;
  let regex = new RegExp('[&\\?]' + name + '=');
  if (regex.test(href)) {
    regex = new RegExp(name + '=' + '(tru|fals)e');
    return href.replace(regex, name + '=' + value);
  } else {
    if (href.indexOf('?') > -1) {
      return href + '&' + name + '=' + value;
    }
    else {
      return href + '?' + name + '=' + value;
    }
  }
}

export const addPreloadParam=(query) => {
  let preload = 'preload';
  let preloadAttribute = (query.includes('?') ? '&' : '?') + preload + '=true';
  return query.includes(preload) ? query : query + preloadAttribute;
}
